import {ForumLinkComposer} from '../../../../utils/forum/ForumLinkComposer';
/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 30.08.13, 13:35
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { JavascriptCallOnSetForumHashFactory } from "./JavascriptCallOnSetForumHashFactory";
import { EnvGlobalsHandler } from "../../../EnvGlobalsHandler";
import { ExternalInterfaceController } from "../../../controller/externalInterface/ExternalInterfaceController";

export class ForumData {
    private _rawServerForumHash: string;

    public /*final*/ updateCryptedForumHash(rawServerHash: string): void {
        // Store raw hash from server
        this._rawServerForumHash = rawServerHash;

        // Notify Javascript about the current raw hash from the game server
        ExternalInterfaceController.instance.executeJavaScriptFunction(new JavascriptCallOnSetForumHashFactory());
    }

    public /*final*/ getForumRootURL(): string {
        return ForumLinkComposer.composeForumURL(this._rawServerForumHash, this.isTest);
    }

    public get rawServerForumHash(): string {
        return this._rawServerForumHash;
    }

    private get isTest(): boolean {
        return EnvGlobalsHandler.globals.isTest || EnvGlobalsHandler.globals.isLocal;
    }
}
